import * as React from 'react';
import { toast } from 'react-toastify';
import DriverTabData from './DriverTab';
import type { DriverJob } from './models/DriverJobInterfaces';
import { DownloadFile, GetQuery } from './Shared';
import { useParams } from 'react-router-dom';

const DriverJobsTomorrowData = () => {
    const { truckId } = useParams();
    const [loading, setLoading] = React.useState(true);
    const [scheduleDateFormatted, setScheduleDateFormatted] = React.useState("");
    const [driverJobs, setDriverJobs] = React.useState<DriverJob[]>([]);

    React.useEffect(() => {
        window.scrollTo(0, 0);

        getData();
    }, []);

    const getData = async () => {
        const apiUrl = "GetDriverJobsTomorrow";
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            setScheduleDateFormatted(result.data.scheduleDateFormatted);
            setDriverJobs(result.data.driverJobs);
            setLoading(false);
        }; 
    }

    const showSiteIssues = (e: any, jobIndex: number) => {
        e.preventDefault();

        var jobs = [...driverJobs]
        var job = jobs[jobIndex];

        job.showSiteIssues = !job.showSiteIssues;

        setDriverJobs(jobs);
    }

    const downloadPlan = (e: any, id: number) => {
        e.preventDefault();
        getPlanFile(id);
    }

    const getPlanFile = async (id: number) => {
        try {
            var filename = "plans.pdf";
            const apiUrl = 'GetJobFile?Id=' + id;
            await DownloadFile(apiUrl, filename);
        } catch (e) {
            toast.error("Error getting job file!");
        }
    }

    const powerlinesText = "Powerlines < 4.6 m";
    var driverTabsMobile = <DriverTabData tab="driverjobs" truckId={Number(truckId)} />

    const renderDetails = (
        <div>
            <div className={driverJobs.length === 0 ? "hidden" : ""}>
                {driverJobs.map((job, index) =>
                    <div key={index}>
                        <div className="makeitflexspacebetween makeitcentervertical">
                            <div className="driverjobs-min20">
                                {index + 1}
                            </div>
                            <div className="makeitbold marginRight10 driverjobs-address">
                                {job.siteAddress}
                                <a className="marginLeft10" href={job.siteAddressGoogle} target="_blank" >
                                    <span className="fas fa-map-marker-alt edit--icon"></span>
                                </a>
                            </div>
                        </div>
                        <div className="makeitflexspacebetween makeitcentervertical">
                            <div>
                                {job.customer}
                            </div>
                            <div className="makeitbold">
                                <span className={job.gateCode ? "" : "hidden"}>g/c: </span>{job.gateCode}
                            </div>
                        </div>
                        <div className="makeitflexspacebetween makeitcentervertical">
                            <div>
                                {job.siteContact}
                            </div>
                            <div className={job.siteHasIssues ? "" : "hidden"}>
                                <i className="fas fa-ban edit--icon--large makeitred" onClick={(e) => showSiteIssues(e, index)}></i>
                            </div>
                        </div>
                        <div className={job.showSiteIssues ? "makeitred" : "hidden"}>
                            <div className={job.truckAccess ? "hidden" : ""}>No Truck Access</div>
                            <div className={job.parking ? "hidden" : ""}>No Parking Available</div>
                            <div className={job.siteClean ? "hidden" : ""}>Site is not clean</div>
                            <div className={job.powerlinesWithinRange ? "" : "hidden"}> {powerlinesText}</div>
                        </div>
                        <div>
                            {job.items.map((item, index) =>
                                <div key={index} className="makeitflexspacebetween">
                                    <div>
                                        {item.unitNumberDisplay === "" ? "" : item.unitNumberDisplay + " - "}
                                        {item.type}
                                    </div>
                                    <div>
                                        {item.item}
                                    </div>
                                    <div>
                                        {item.itemQuantityType}
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="makeititalic driverjobs--notes">
                            {job.jobNotes}
                        </div>
                        <div className="alignitemscentre">
                            <div className={job.plans.length > 0 ? "" : "hidden"}>
                                {job.plans.map(plan =>
                                    <div key={plan.id}>
                                        <a href="#" onClick={(e) => downloadPlan(e, plan.id)}>{plan.fileName}</a>
                                    </div>
                                )}

                            </div>
                        </div>
                        <hr className="hr--no-margin"></hr>
                    </div>
                )}
            </div>
            <div className={driverJobs.length === 0 ? "" : "hidden"}>
                There are no jobs allocated to you for this date yet.
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            <div className="mobileFont marginTop10 marginBottom70">
                <div className="makeitflexspacebetween marginBottom10">
                    <h1>Jobs for {scheduleDateFormatted}</h1>
                </div>
            
                <hr></hr>
                {contents}
            </div>
            <div>
                {driverTabsMobile}
            </div>
        </div>
    );
}

export default DriverJobsTomorrowData;
